import { render, staticRenderFns } from "./PersonalDocuments.vue?vue&type=template&id=1acdfd5e"
import script from "./PersonalDocuments.vue?vue&type=script&lang=js"
export * from "./PersonalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports